import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS, CONTENT_ALIAS } from '../const.config';

// Watch sessions module configurations
export const LISTING_COLUMNS = [
  {
    id: 'sessionId',
    label: 'Session ID',
    width: '10%',
    align: 'left',
    dataKey: 'sessionId',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'firstName',
    label: 'First Name',
    width: '10%',
    align: 'left',
    dataKey: 'firstName',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'lastName',
    label: 'Last Name',
    width: '10%',
    align: 'left',
    dataKey: 'lastName',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'email',
    label: 'Email Address',
    width: '15%',
    align: 'left',
    dataKey: 'email',
    sortable: true,
    type: CELL_DATA_TYPES.EMAIL,
  },
  {
    id: 'video',
    label: `${CONTENT_ALIAS.VIDEO_SINGULAR}`,
    width: '20%',
    align: 'left',
    dataKey: 'videoTitle',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'ip',
    label: 'IP Address',
    width: '10%',
    align: 'left',
    dataKey: 'ip',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'sessionStartTime',
    label: 'Session Start Time',
    width: '15%',
    align: 'left',
    dataKey: 'sessionStartedAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'watchedSeconds',
    label: 'Total Watched',
    width: '10%',
    align: 'right',
    dataKey: 'videoProgressSeconds',
    sortable: true,
    type: CELL_DATA_TYPES.DURATION,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'sessionId',
    label: 'Session ID',
    dataKey: 'sessionId',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'firstName',
    label: 'First Name',
    dataKey: 'subscriberFirstName',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'lastName',
    label: 'Last Name',
    dataKey: 'subscriberLastName',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'email',
    label: 'Email Address',
    dataKey: 'email',
    type: CELL_DATA_TYPES.EMAIL,
  },
  {
    id: 'videoTitle',
    label: `${CONTENT_ALIAS.VIDEO_SINGULAR}`,
    dataKey: 'videoTitle',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'ip',
    label: 'IP Address',
    dataKey: 'ip',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'sessionStartTime',
    label: 'Session Start Time',
    dataKey: 'sessionStartedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'sessionEndedAt',
    label: 'Session End Time',
    dataKey: 'sessionEndedAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'videoPlayedFrom',
    label: `${CONTENT_ALIAS.VIDEO_SINGULAR} Played From`,
    dataKey: 'videoPlayedFrom',
    type: CELL_DATA_TYPES.DURATION,
  },
  {
    id: 'watchedSeconds',
    label: 'Total Watched',
    dataKey: 'videoWatchProgress',
    type: CELL_DATA_TYPES.DURATION,
  },
];
